module.exports = __webpack_public_path__ + "img/mag.d0c39b53.png";